/**
 * Per-district accent colors (one per family turf). Shared by the City Map
 * (hex tinting, turf labels) and the Districts page (card accent rail, crest
 * glow) so the two screens always agree on a family's color. Keyed by
 * districtId — do not duplicate this map elsewhere.
 */
export const DISTRICT_ACCENT: Record<string, string> = {
  'the-docks':      '#5b9bd5', // Doyle Crew — harbor blue
  'gallows-row':    '#7fb069', // Gallows Boys — bile green
  'little-italy':   '#c0504d', // Moretti Family — red
  'the-foundry':    '#d98e32', // Kowalski Syndicate — furnace orange
  'the-ashlands':   '#9a9a9a', // Cinder Court — ash gray
  'blood-alley':    '#c94f7c', // Red Lantern Tong — lantern crimson
  'dead-mans-pier': '#5fc2ad', // The Widow's Hand — sea teal
  'the-heights':    '#c8a24c', // The Commission — gold
  'old-market':     '#d0a45f', // The Ledger Boys — brass ledger
  'freightyards':   '#8093a6', // The Switchmen — signal steel
  'gin-mile':       '#c96a9e', // Velvet Chorus — cabaret rose
  'motor-row':      '#cf6a3c', // The Carbide Club — oxblood chrome
};

/** Fallback accent for a districtId this map doesn't (yet) know about. */
const DEFAULT_ACCENT = '#888888';

/** Accent color for a district, with a safe fallback. */
export const districtAccent = (districtId?: string | null): string =>
  (districtId && DISTRICT_ACCENT[districtId]) || DEFAULT_ACCENT;

/** hex ('#rrggbb') → `rgba(r,g,b,alpha)` — used for turf tint fills and glows. */
export function accentRgba(hex: string, alpha: number): string {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${alpha})`;
}
